import loadable from '@loadable/component';

const DataIngestion = loadable(() => import('./page'));
const DataIngestionNewPAge = loadable(() => import('./new/page'));
const DataIngestionDetailPage = loadable(() => import('./[id]/page'));


export const routes = [
  {
    path: '',
    element: <DataIngestion />,
  },
  {
    path: 'new',
    element: <DataIngestionNewPAge />,
  },
  {
    path: ':id',
    element: <DataIngestionDetailPage />,
  }
];